import type { ReactNode } from 'react';

import { Box } from 'components/Box/Box';
import { LegacyTooltip } from 'components/LegacyTooltip/LegacyTooltip';

import {
  ListingViewSectionHolder,
  ListingViewSectionTitle,
} from './ListingViewSection.styled';

type Props = {
  id?: string;
  title?: string;
  tooltip?: string;
  children: ReactNode;
  noBorderTop?: boolean;
};

export function ListingViewSection({
  id,
  title,
  tooltip,
  children,
  noBorderTop,
}: Props) {
  return (
    <ListingViewSectionHolder id={id} $noBorderTop={Boolean(noBorderTop)}>
      {(title || tooltip) && (
        <ListingViewSectionTitle>
          {title}

          {tooltip && (
            <Box ml="6px" display="inline-block" position="relative" top="-3px">
              <LegacyTooltip>{tooltip}</LegacyTooltip>
            </Box>
          )}
        </ListingViewSectionTitle>
      )}

      {children}
    </ListingViewSectionHolder>
  );
}
